{
  "app": {
    "nom": "CAI — Centre d'Alertes i Incidències",
    "nomCurt": "CAI",
    "logo": "CAI",
    "descripcio": "Centro de Alertas e Incidencias",
    "organitzacio": "bonÀrea · {{entorn}}",
    "logoAlt": "BAtech"
  },
  "login": {
    "titol": "CAI — Centre d'Alertes i Incidències",
    "subtitol": "Portal de gestión de activaciones, guardias y comunicaciones de crisis de bonÀrea.",
    "boto": "Iniciar sesión con Microsoft",
    "peu": "Acceso restringido a personal interno con cuenta bonÀrea.",
    "mock": "Modo de desarrollo: sesión simulada",
    "perfilMock": "Perfil simulado",
    "titolMarca": "Centro de Alertas e Incidencias",
    "peu2": "Uso sujeto a la política de seguridad corporativa.",
    "marca": "BAtech · bonÀrea"
  },
  "perfilsMock": {
    "ADMIN": "Administrador",
    "RESPONSABLE_DEPARTAMENT": "Responsable de departamento",
    "RESPONSABLE_SEGURETAT": "Responsable de seguridad",
    "TECNIC": "Técnico de guardia",
    "STANDARD": "Estándar (reporta)"
  },
  "nav": {
    "principal": "Navegación principal",
    "torna": "← {{seccio}}",
    "seccions": {
      "centre": "Centro de control",
      "activacions": "Activaciones",
      "guardies": "Guardias",
      "analisi": "Análisis",
      "ajustos": "Configuración"
    },
    "pestanyes": {
      "calendari": "Calendario",
      "cobertura": "Cobertura",
      "sollicituds": "Solicitudes",
      "experts": "Expertos",
      "historial": "Historial",
      "indicadors": "Indicadores",
      "informes": "Informes",
      "recurrents": "Recurrentes",
      "registre": "Registro"
    }
  },
  "cerca": {
    "placeholder": "Buscar activaciones, personas…"
  },
  "idioma": {
    "etiqueta": "Idioma",
    "ca": "Català",
    "es": "Castellano"
  },
  "sessio": {
    "tanca": "Cerrar sesión",
    "carregant": "Cargando…",
    "iniciant": "Iniciando la sesión…",
    "menu": "Menú de la cuenta",
    "canviaCompte": "Cambiar de cuenta",
    "elMeuMobil": "Mi móvil"
  },
  "telefon": {
    "onboardingTitol": "Confirma tu móvil",
    "onboardingText": "El CAI te avisará por SMS y llamada en este número cuando estés de guardia o se active un servicio. ¿Es tu móvil?",
    "onboardingSense": "No tienes ningún móvil en tu perfil. Añade uno para continuar.",
    "titolPerfil": "Mi móvil",
    "textPerfil": "Número donde el CAI te enviará los avisos por SMS y llamada.",
    "etiqueta": "Móvil",
    "placeholder": "6XX XXX XXX",
    "ajuda": "9 dígitos, debe empezar por 6 o 7.",
    "invalid": "El móvil debe tener 9 dígitos y empezar por 6 o 7.",
    "esCorrecte": "Sí, es correcto",
    "canvia": "Cambiar el número",
    "desa": "Guardar",
    "cancella": "Cancelar",
    "desat": "Móvil guardado"
  },
  "estatPagina": {
    "senseAccesTitol": "Sin acceso",
    "senseAccesText": "No tienes permiso para consultar esta pantalla.",
    "noTrobatTitol": "Página no encontrada",
    "noTrobatText": "La página que buscas no existe.",
    "errorTitol": "No se ha podido cargar",
    "errorText": "Se ha producido un error al conectar con el servidor.",
    "reintenta": "Vuelve a intentarlo",
    "tornaInici": "Volver al inicio",
    "pendentText": "Pantalla {{id}} · en construcción."
  },
  "accions": {
    "desar": "Guardar",
    "cancellar": "Cancelar",
    "enviar": "Enviar",
    "seguent": "Siguiente",
    "enrere": "Atrás",
    "editar": "Editar",
    "eliminar": "Eliminar",
    "cerca": "Buscar",
    "confirmar": "Confirmar",
    "acceptar": "Aceptar",
    "tancar": "Cerrar",
    "exportar": "Exportar",
    "tria": "Elige…",
    "senseResultats": "Sin resultados"
  },
  "tempsReal": {
    "connectat": "Tiempo real conectado",
    "connectant": "Conectando tiempo real…",
    "desconnectat": "Tiempo real desconectado"
  },
  "tipusActivacio": {
    "AVIS": "Aviso",
    "INCIDENCIA": "Incidencia",
    "CRITICA": "Crítica"
  },
  "comunicacio": {
    "PREVENTIVA": "Comunicación preventiva",
    "REACTIVA": "Comunicación reactiva",
    "CRITICA": "Comunicación crítica"
  },
  "tipusArea": {
    "GUARDIA_IT": "Guardia",
    "CRISI": "Crisis"
  },
  "estatActivacio": {
    "OBERTA": "Abierta",
    "EN_CURS": "En curso",
    "RESOLTA": "Resuelta",
    "MITIGADA": "Mitigada",
    "CANCELLADA": "Cancelada",
    "FINALITZADA": "Finalizada"
  },
  "estatDestinatari": {
    "PENDENT": "Pendiente",
    "ENVIAT": "Enviada",
    "LLIURAT": "Entregada",
    "LLEGIT": "Leída",
    "CONFIRMAT": "Confirmada",
    "FALLIT": "Fallida",
    "EXPIRAT": "Expirada",
    "EN_ESPERA": "En espera",
    "NO_NOTIFICAT": "No notificado"
  },
  "blocDestinatari": {
    "TECNIC_GUARDIA": "Técnico de guardia",
    "USUARIS_INFORMAR": "Usuarios a informar",
    "TECNIC_EXPERT": "Técnico experto",
    "ADDICIONAL": "Destinatarios adicionales"
  },
  "canal": {
    "PUSH": "Push",
    "PUSH_CRITICA": "Push crítica",
    "EMAIL": "Correo electrónico",
    "TRUCADA": "Llamada"
  },
  "cobertura": {
    "COBERTA": "Cubierta",
    "SENSE_COBERTURA": "Sin cobertura"
  },
  "ambit": {
    "GLOBAL": "Global",
    "DEPARTAMENT": "Departamento",
    "AREA": "Área",
    "SERVEI": "Servicio"
  },
  "avisos": {
    "nova": "Nueva activación",
    "critica": "Activación crítica",
    "mencio": "Mención en el chat",
    "missatgeA": "Nuevo mensaje en {{codi}}"
  }
}
